import React, { useState, useContext } from 'react';
import { AppBar, Toolbar, Typography, IconButton, FormControl, MenuItem, ListItemIcon, Box, ListItemText, Drawer, ListItem, Select, Dialog, DialogContent, DialogActions, Button } from '@mui/material';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import ViewCarouselIcon from '@mui/icons-material/ViewCarousel';
import CompareIcon from '@mui/icons-material/Compare';
import AnimationIcon from '@mui/icons-material/Animation';
import ViewStreamIcon from '@mui/icons-material/ViewStream';
import MenuIcon from '@mui/icons-material/Menu';
import TerminalIcon from '@mui/icons-material/Terminal';
import { useNavigate } from 'react-router-dom'; 
import { useSnackbar } from 'notistack';
import TokenContext from './TokenContext';
import countries from '../country.json';

import ImageIcon from '@mui/icons-material/Image'; // Icono para "Banners"
import PeopleIcon from '@mui/icons-material/People'; // Icono para "Usuarios"
import ExitToAppIcon from '@mui/icons-material/ExitToApp'; // Icono para "Salir"



function Header({ onCountryChange, countryCode }) {
  const { token, setToken } = useContext(TokenContext);
  const navigate = useNavigate(); 
  const { enqueueSnackbar } = useSnackbar();
  const [mcpOpen, setMcpOpen] = useState(false);

  const [sidebarOpen, setSidebarOpen] = useState(false); // Estado para la visibilidad del sidebar

  const decodeTokenPayload = (jwt) => {
    try {
        const base64Payload = jwt.split('.')[1];
        const jsonString = atob(base64Payload); // atob es una función nativa de JS para decodificar base64
        return JSON.parse(jsonString);
    } catch (e) {
        console.error("Error decoding JWT:", e);
        return null;
    }
}

function extractFirstNameFromEmail(email) {
  try {
      const namePart = email.split('@')[0]; // Divide por '@' y toma la primera parte.
      const firstName = namePart.split('.')[0]; // Divide por '.' y toma la primera parte (nombre).

      // Capitaliza la primera letra y devuelve.
      return firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
  } catch (e) {
      console.error("Error extracting name from email:", e);
      return null;
  }
}

  const payload = decodeTokenPayload(token);
  const email = payload ? payload.sub : null;
  const name = extractFirstNameFromEmail(email);
  const isAdmin = payload.roles.includes('ADMIN');

  const handleLogout = () => {
    setToken(null);
    localStorage.removeItem('token');
    navigate('/'); 
  };

  const handleChange = (event) => {
    onCountryChange(event.target.value);
  };

  const mcpCommand = `claude mcp add --transport http home-widgets ${countries.co.host}/core-home-proxy/cauth/mcp`;

  const handleCopyMcpCommand = async () => {
    try {
      await navigator.clipboard.writeText(mcpCommand);
      enqueueSnackbar('Comando copiado', { variant: 'success' });
      setMcpOpen(false);
    } catch (e) {
      enqueueSnackbar('No se pudo copiar', { variant: 'error' });
    }
  };

  // Funciones para manejar la apertura y cierre del sidebar
  const handleSidebarOpen = () => {
    setSidebarOpen(true);
  };

  const handleSidebarClose = () => {
    setSidebarOpen(false);
  };



  return (
    <>
        <AppBar
            position="static"
            sx={{ background: 'linear-gradient(45deg, #FF7A4D 37%, #FF2526 90%)', height: '75px' }}
        >
            <Toolbar sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography
                    variant="h3"
                    component="div"
                    sx={{ flexGrow: 1, textAlign: 'center', fontFamily: 'Poppins', fontWeight: 'bold' }}
                >
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <FormControl variant="outlined" size="small" sx={{ marginRight: 3 }}>
                        <Select
                            value={countryCode}
                            onChange={handleChange}
                            sx={{ bgcolor: 'white', '& .MuiOutlinedInput-notchedOutline': { borderColor: 'white', } }}
                        >
                            {Object.values(countries).map((country) => (
                                <MenuItem key={country.iso_code} value={country.iso_code}>
                                    <Box display="flex" alignItems="center">
                                        <ListItemIcon sx={{ minWidth: 'auto', marginRight: 1 }}>
                                            <img src={"./flags/" + country.iso_code + ".svg"} alt={country.name} width="24" height="24" />
                                        </ListItemIcon>
                                        <ListItemText primary={country.name} sx={{ lineHeight: '24px' }} />
                                    </Box>
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Box>

                <IconButton
                    edge="end"
                    color="inherit"
                    aria-label="menu"
                    onClick={handleSidebarOpen}
                    sx={{ marginRight: 2, alignSelf: 'center', fontSize: '1.5rem' }}
                >
                    <MenuIcon />
                </IconButton>

       
            </Toolbar>
        </AppBar>
        <img
            src="https://rappi-uploads-02-prod.s3.us-west-2.amazonaws.com/home-ab-objects/1680658815.png"
            alt="logo"
            style={{ position: 'absolute', top: '8%', left: 0, height: '150px', transform: 'translateY(-50%)' }}
        />

        <Drawer
            anchor="right"
            open={sidebarOpen}
            onClose={handleSidebarClose}
        >
            <Box sx={{ width: 350, pb: 6 /* espacio para la barra de versión */ }}>
                
                {/* Aquí insertas el código del header del sidebar */}
                <Box sx={{ 
                    height: 200, 
                    backgroundColor: '#2C2C2C',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}>
                    <img 
                        src="https://rappi-images-upload-co.s3.amazonaws.com/home-ab-objects/dino-rappi.png"
                        alt="Perfil"
                        style={{
                            borderRadius: '50%', 
                            width: '80px',
                            height: '80px',
                            marginBottom: '10px'
                        }}
                    />
                    <Typography variant="h5" color="white">{name}</Typography>
                </Box>
                <ListItem 
                    button 
                    onClick={() => {
                        navigate('/banners');
                        handleSidebarClose();
                    }}
                >
                    <ListItemIcon>
                        <ViewCarouselIcon />
                    </ListItemIcon>
                    <ListItemText primary="Banners" primaryTypographyProps={{ fontWeight: 'bold' }} />
                </ListItem>
                <ListItem 
                    button 
                    onClick={() => {
                        navigate('/carousels');
                        handleSidebarClose();
                    }}
                >
                    <ListItemIcon>
                        <ViewStreamIcon />
                    </ListItemIcon>
                    <ListItemText primary="Carousels" primaryTypographyProps={{ fontWeight: 'bold' }} />
                </ListItem>
                <ListItem 
                    button 
                    onClick={() => {
                        navigate('/images');
                        handleSidebarClose();
                    }}
                >
                    <ListItemIcon>
                        <CompareIcon />
                    </ListItemIcon>
                    <ListItemText primary="Images" primaryTypographyProps={{ fontWeight: 'bold' }} />
                </ListItem>
                {isAdmin && (
                    <ListItem 
                        button 
                        onClick={() => {
                            navigate('/lotties');
                            handleSidebarClose();
                        }}
                    >
                        <ListItemIcon>
                            <AnimationIcon />
                        </ListItemIcon>
                        <ListItemText primary="Lotties" primaryTypographyProps={{ fontWeight: 'bold' }} />
                    </ListItem>
                )}
                {isAdmin && (
                    <ListItem 
                        button 
                        onClick={() => {
                            navigate('/users');
                            handleSidebarClose();
                        }}
                    >
                        <ListItemIcon>
                            <PeopleIcon />
                        </ListItemIcon>
                        <ListItemText primary="Users" primaryTypographyProps={{ fontWeight: 'bold' }} />
                    </ListItem>
                )}
                {isAdmin && (
                    <ListItem 
                        button 
                        onClick={() => {
                            handleSidebarClose();
                            setMcpOpen(true);
                        }}
                    >
                        <ListItemIcon>
                            <TerminalIcon />
                        </ListItemIcon>
                        <ListItemText primary="MCP" primaryTypographyProps={{ fontWeight: 'bold' }} />
                    </ListItem>
                )}
                <ListItem 
                    button 
                    onClick={() => {
                        handleLogout();
                        handleSidebarClose();
                    }}
                >
                    <ListItemIcon>
                        <ExitToAppIcon />
                    </ListItemIcon>
                    <ListItemText primary="Log out" primaryTypographyProps={{ fontWeight: 'bold' }} />
                </ListItem>
            </Box>
            <Box
                sx={{
                    position: 'fixed',
                    bottom: 0,
                    right: 0,
                    width: 350,
                    bgcolor: '#f5f5f5',
                    color: '#333',
                    textAlign: 'center',
                    py: 0.5,
                    fontSize: 12,
                    zIndex: 1301,
                    borderTop: '1px solid #e0e0e0'
                }}
            >
                v1.0.0
            </Box>
        </Drawer>
      <Dialog open={mcpOpen} onClose={() => setMcpOpen(false)} maxWidth="sm" fullWidth>
        <DialogContent sx={{ pt: 3 }}>
          <Box
            component="pre"
            sx={{
              m: 0,
              p: 2,
              bgcolor: '#f7f7f8',
              border: '1px solid #e8e8ea',
              borderRadius: '10px',
              fontFamily: '"SF Mono", Menlo, Consolas, monospace',
              fontSize: '0.8rem',
              lineHeight: 1.6,
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-all',
            }}
          >
            {mcpCommand}
          </Box>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={() => setMcpOpen(false)}>Cerrar</Button>
          <Button variant="contained" onClick={handleCopyMcpCommand}>Copiar</Button>
        </DialogActions>
      </Dialog>
    </>
);

}

export default Header;
